import React from 'react';

type Props = {
  title: string;
};

export const TitleTv: React.FC<Props> = ({ title }) => <h1 className="tv-title mb-0">{title}</h1>;
